/**
 * Drives a batched server write (merge, venue sync) until nothing remains.
 *
 * Stops and rethrows on the first error: every batch is idempotent server-side, so calling
 * again continues where this one stopped. Throws when a batch does nothing yet work remains,
 * so a stuck server cannot make this loop write forever. Resolves with the total done.
 */
export async function runBatches(
  step: () => Promise<{ done: number; remaining: number }>,
  onProgress: (done: number, remaining: number) => void,
): Promise<number> {
  let total = 0;
  for (;;) {
    const { done, remaining } = await step();
    total += done;
    onProgress(total, remaining);
    if (remaining <= 0) return total;
    if (done === 0) throw new Error(`No progress: ${remaining} venues remain`);
  }
}
